import {Component, OnInit} from '@angular/core';
import {OktaAuthService} from "@okta/okta-angular";
// import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {DashboardContactInfoComponent} from "../../components/dashboard-contact-info/dashboard-contact-info.component";
import {MatDialog} from "@angular/material/dialog";
import {DataService} from "../../services/data.service";
import {HttpErrorResponse} from "@angular/common/http";
import {PaidCommissionsComponent} from "../../components/dialog/paid-commissions/paid-commissions.component";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  currentDate: Date = new Date();
  gasGraphData;
  powerGraphData;
  userData = {};
  brokerInfo;
  powerObservationDate;
  gasObservationDate;
  distinctNodes: string[] = [];
  nodeValue: string = "";
  gasGraphLoading: boolean = false;
  powerGraphLoading: boolean = false;
  constructor(private oktaAuth: OktaAuthService, private dialog: MatDialog, private dataService: DataService) {

  }

  async ngOnInit(): Promise<void> {
    const accessToken = this.oktaAuth.getAccessToken();
    this.oktaAuth.getUser().then(data => {
      this.userData = data;
    })
    await this.dataService.getBrokerInfo().toPromise().then(res => {
      this.brokerInfo = res;
    }).catch((err: HttpErrorResponse) => {

    });
    await this.dataService.getDistinctNodes().toPromise().then(res => {
      this.distinctNodes = res as string[];
      this.nodeValue = res[0] as string;
      this.getPowerChartData(res[0]);
    })
    // await this.dataService.getMarketData('prices').toPromise().then(res => {
    //   this.powerGraphData = this.makeGraphData(res, 'prices');
    // }).catch((err: HttpErrorResponse) => {
    //
    // })
    this.gasGraphLoading = true;
    await this.dataService.getMarketData('natgas').toPromise().then(res => {
        this.gasGraphData = this.makeGraphData(res, 'natgas');
    }).catch((err: HttpErrorResponse) => {

    }).finally(() => {
      this.gasGraphLoading = false;
    })

  }
  async getPowerChartData(nodeVal: string){
    this.powerGraphLoading = true;
    await this.dataService.getMarketData(`calendarizedpowerbynode/${nodeVal}`).toPromise().then(res => {
      this.powerGraphData = this.makeGraphData(res, 'prices');
    }).catch((err: HttpErrorResponse) => {

    }).finally(() => {
      this.powerGraphLoading = false;
    })
  }
  makeGraphData(data, graphType){
    let graphData = {
      series: [],
      xaxis: []
    };
    data.forEach(item => {
      let seriesNodes = graphData.series.map(item => item.name).filter(item => item != undefined),
        node = graphType == 'natgas' ? item.product: item.calStrip || item.node,
        price = graphType == 'natgas' ? item.currentPrice: [new Date(item.observationDate).getTime(), item.atcPrice];
      if(seriesNodes.includes(node)){
        graphData.series[seriesNodes.indexOf(node)]['data'].push(price);
      }else {
        if(node.indexOf('Prompt') !== -1) {
          graphData.series.unshift({name: node, data: [price]});
        }else{
          graphData.series.push({name: node, data: [price]});
        }
      }
      graphData.xaxis.push(item.prevailingStartDate || item.observationDate);
    })
    let xAxis = [];
    graphData.xaxis.forEach(item => {
      if(!xAxis.includes(item)){
        xAxis.push(item);
      }
    })
    graphData.xaxis = xAxis;
    return graphData;
  }
  openContactInfo(): void{
    const dialogRef = this.dialog.open(DashboardContactInfoComponent, {data: null});
    // const closeListener = dialogRef.componentInstance.dialogClose.subscribe(()=>{
    //   dialogRef.close();
    // });
    //
    // dialogRef.afterClosed().subscribe(result => {
    //   closeListener.unsubscribe();
    // });
  }
  openPaidCommissionsDialog(): void{
    const dialogRef = this.dialog.open(PaidCommissionsComponent, {data: null});
    const closeListener = dialogRef.componentInstance.closePaidCommission.subscribe(()=>{
      dialogRef.close();
    });
    //
    dialogRef.afterClosed().subscribe(result => {
      closeListener.unsubscribe();
    });
  }
  powerObservation(data){
    this.powerObservationDate = data;
  }
  gasObservation(data){
    this.gasObservationDate = data;
  }

  distinctNodeChange(e){
    this.getPowerChartData(e.value);
  }

}
